import * as Immutable from "immutable";
import * as React from "react";
import { Action, IOWidget, mk_widget, mk_pair, none, loadingAsyncState, some, AsyncState, async } from "widgets-for-react";
import { Id, CMSState, ImageSize, Url } from "../../../../cms/blocks/types.gen";
import { ExtraImages } from "../../../utils/extra_images.mod";
import { maps_no_stateful } from "../../../../map/maps"
import { center_rotterdam, example_plus, sample_MapStyling, apply_layer, provider, params_to_string, setQueryStringParameter, update_params, markerIconSelected, markerIcon, MapListItem, getDistance } from "../../../../map/maps_utils";
import { CustomBlockData } from "../types.mod";
import { MapEntity, MapsState, CenterMarker, SearchResult, OpenStreetMapProviderResultRaw, CategoriesList, SimpleList, MapSearchResult, PresentationState } from "../../../../map/maps_types";
import { PublicSite_CustomPageData } from "../../../application.mod";
import { PublicSiteState } from "../../../../public_site.main.mod";
import { gtmPush } from "../../../../../helpers";

export type AddressType = {
  BillingCity: string
  BillingLatitude: number
  BillingLongitude: number
  BillingPostalCode: string
  BillingStreet: string
  Name: string
  Phone: string,
  Website: string
}

export const formatUrl: (url?: string) => string = (url: string) => {
  return url ? url.startsWith('http') ? url : `http://${url}` : null
}

export let get_addresses = () : AsyncState<Immutable.List<MapEntity>> => {
  return loadingAsyncState(async () => {
    let address = `/api/v1/Map/GetAddresses`
    let _fetch = await fetch(address)
    let res = await _fetch.json()
    let res1 = Immutable.List<MapEntity>(res.value.sort((a, b) => { 
      let rand:number = Math.random()
      if (rand > 0.5) return 1
      if (rand < 0.5) return -1
      return 0
    })
    .map((a:AddressType) => ({
        position:{lat:a.BillingLatitude, lng:a.BillingLongitude},
        info_when_on_list:(e, presentation_mode:PresentationState) => 
        <MapListItem 
          title={a.Name}
          address={`${a.BillingStreet}, ${a.BillingPostalCode} ${a.BillingCity}`}
          phoneNumber={a.Phone}
          presentationMode={presentation_mode.value.kind}
          websiteURL={formatUrl(a.Website)}
        />,
        info_when_on_map:e => <div className="map-modal">
          <h3 className="map-modal__title typo--m">
            {a.Name}
          </h3>
    
          <div className="map-modal__address typo--s">
            {a.BillingStreet}<br />
            {a.BillingPostalCode} {a.BillingCity}<br />
            <a className="map-modal__phone" href={`tel:${a.Phone}`} onClick={_ => {gtmPush({ category: 'Locator', action: 'Map telephone', label: a.Name })}}>
              {a.Phone}
            </a>
          </div>
          { a.Website && 
            <a href={formatUrl(a.Website)} target='_blank' className="map-modal__link link link--white" onClick={_ => {
              gtmPush({ category: 'Locator', action: 'Map website', label: a.Name  })
            }}>
              Bekijk de website
            </a>
          }

        </div>,
        show_info_on_map:"on_click",
        icon:e => e.selection_status != "none" ? markerIconSelected : markerIcon,
        selection_status:"none"
      } as MapEntity)))
    return {kind:"result", status:200, value:res1}
  })
}

export type mapBlockProps = {  
  block_index: number,
  state:MapsState,
  addresses:AsyncState<Immutable.List<MapEntity>>
}

export type mapBlockStyle = Partial<{
}>

export function mapBlock(
  props: mapBlockProps,
  options?: { style: mapBlockStyle; key?: string }
): (s:CMSState<CustomBlockData, ExtraImages, PublicSite_CustomPageData>) => IOWidget<PublicSiteState, Action<CMSState<CustomBlockData,ExtraImages, PublicSite_CustomPageData>>> {
  return (s: CMSState<CustomBlockData,ExtraImages, PublicSite_CustomPageData>) => (public_state:PublicSiteState) =>
    mk_widget({
      run: set_state => {

        let widget = maps_no_stateful(props.state).run(future_state => {
          let new_state= future_state(props.state)
          set_state(s => {

            let currentBlock = s.blocks.get(props.block_index) as any

            if (currentBlock.kind === "mapBlock") {
              currentBlock = {
                ...currentBlock,
                value: mk_pair(
                  {
                    ...currentBlock.value.fst,
                    state: { ...new_state, route_state: "none" }
                  },
                  currentBlock.value.snd
                )
              };
            }

            let route_params1:{param: string;value: string;}[][]  = undefined
            if (s.custom_page_data.v.kind == "r") {
              route_params1 = s.custom_page_data.v.v.extra_params;
              if (new_state.route_state == "update") {
                route_params1 = s.custom_page_data.v.v.extra_params || [
                  [{ param: "kind", value: "map" }]
                ];
                route_params1 = update_params(new_state, route_params1);
                let route_params1_string = params_to_string(route_params1);
                setQueryStringParameter("queryParams", route_params1_string);
              }
            }

            return {
              ...s,
              blocks: s.blocks.set(props.block_index, currentBlock),
              custom_page_data:
                s.custom_page_data.v.kind == "l"
                  ? none<PublicSite_CustomPageData>()
                  : some<PublicSite_CustomPageData>({
                      ...s.custom_page_data.v.v,
                      extra_params: route_params1
                    })
            };
          })
        })      
        return <>
          {async<Immutable.List<MapEntity>>()(get_addresses()).run(a => {
            set_state(s => {
              let currentBlock = s.blocks.get(props.block_index) as any

              if (currentBlock.kind === "mapBlock") {
                let new_addresses = a(currentBlock.value.fst.addresses)
                let entity = currentBlock.value.fst.state

                currentBlock = {
                  ...currentBlock,
                  value: mk_pair(
                    {
                      ...currentBlock.value.fst,
                        addresses: new_addresses,
                        state: { ...entity, 
                            data_to_display: {
                              ...entity.data_to_display, 
                                entities:new_addresses.kind == "loaded" ? new_addresses.value : entity.data_to_display.entities,
                            },
                            optional_bounds:new_addresses.kind == "loaded" 
                              ? new_addresses.value.map(p => ([p.position.lat, p.position.lng] as [number, number]))
                                                    .filter(p => getDistance({lat:p[0], lng:p[1]}, entity.center_marker.position) < 3000)
                                                    .toArray()
                              : entity.optional_bounds,
                            search_status:  new_addresses.kind == "loaded" && entity.search_status.kind == "input" && 
                                            entity.search_status.value != undefined && entity.search_status.value != ""
                                              ? { kind: "search", 
                                                  value: entity.search_status.value, 
                                                  async: search(entity.search_status.value, null, true) }
                                              : entity.search_status                            
                          }
                    },
                    currentBlock.value.snd
                  )
                };
              }

              return {...s, blocks: s.blocks.set(props.block_index, currentBlock)}
            })
          })}
          {widget}
          </>
      }
    })
}
let search = (input:string, current_state:MapsState, called_from_route?:boolean) => {
  debugger
  return loadingAsyncState(async () => {
    let new_input = ""
    let maybe_postcode = 0
    for (let i = 0; i < input.length; i++) {
      const current_c = input[i];
      //bad, the search cannot see that 2901je is the same as 2901 je. this means that we need to remove that space
      if(current_c != " "  && !isNaN(+current_c)){
        maybe_postcode += 1
        new_input += current_c
      }
      else{
        if(maybe_postcode == 4 && current_c == " "){
          //we skip
        }
        else{
          new_input += current_c
        }
        maybe_postcode = 0
      }
    }

    let results = await provider.search({ query: new_input.trim() });
    //results will contain the lat/long associated to the input search and an optional new set of data
    console.log(results)
    let new_res : MapSearchResult = 
      {
        centers: results as SearchResult<OpenStreetMapProviderResultRaw>[], 
        new_data: none<CategoriesList | SimpleList>(),
      }
    return { kind:"result",status:200,value:new_res }
  })
}
export let conneqt_x_map = (route_params?: { param: string; value: string; }[][], city?:string) : MapsState => {    
    return {
      route_state: "none",
      center_marker: {
        position: center_rotterdam,
        icon: (entity_state: CenterMarker) => example_plus
      },
      presentation_mode: {
        value: { kind: "show map" },
        default_list_range: 5000,
        delta_increase_range_value: 5000
      },
      header: (state: MapsState) => {
        return mk_widget({
          run: set_state => {
            return (
              <div className={`${state.styling.root__map__actions} `}>
                <div
                  className={`${state.styling.root__switch} ${
                    state.styling.root__switch
                  }--${
                    state.presentation_mode.value.kind == "show list"
                      ? "right"
                      : "left"
                  }`}
                  onClick={() =>
                    set_state(s => ({
                      ...s,
                      route_state: "update",
                      map: "none",
                      presentation_mode: {
                        ...s.presentation_mode,
                        value:
                          s.presentation_mode.value.kind == "show map"
                            ? {
                                kind: "show list",
                                current_range:
                                  s.presentation_mode.default_list_range
                              }
                            : {
                                kind: "show map"
                              }
                      }
                    }))
                  }
                >
                  <div className={state.styling.root__switch__item}>kaart</div>
                  <div className={state.styling.root__switch__item}>lijst</div>
                </div>
                {/*           
                  <button disabled={state.presentation_mode.value.kind == "show list"}
                          onClick={() => set_state(s => ({...s, 
                          route_state:"update",
                          map:"none",
                          presentation_mode:{...s.presentation_mode, value:{kind:"show list", current_range:s.presentation_mode.default_list_range}}}))}>List</button>
                  <button disabled={state.presentation_mode.value.kind == "show map"}
                          onClick={() => set_state(s => ({...s, 
                          route_state:"update",
                          presentation_mode:{...s.presentation_mode, value:{kind:"show map"}}}))}>Map</button> */}
              </div>
            );
          }
        });
      },
      last_center_on_map: "none",
      default_center: center_rotterdam,
      internal_cluster_key: 0,
      last_event: "none",
      list_title: "Adviseurs bij jou in de buurt",
      map: "none",
      max_zoom: 19,
      styling: sample_MapStyling,
      search_label: "Vind een adviseur in de buurt van:",
      search_status: { kind: "input", value: city ? city : "" },
      map_tile_provider: {
        default_tile_provider: "CartoDB.Positron",
        list_tile_provides: Immutable.List([
          {
            name: "CartoDB.Positron",
            apply: (map: L.Map) => {
              apply_layer("CartoDB.Positron", map);
            }
          }
        ])
      },
      default_search_function: search,
      last_searched_center: "none",
      data_to_display: {
        kind: "simple_list",
        entities: Immutable.List()//generateMapEntity(center_rotterdam, 2000, 50)
      }
    };
  }

  //http://localhost:5000/?queryParams=kind$map!city$rotterdam!view$list!zoom$13&slug=sample-page


// WEBPACK FOOTER //
// ./Client/components/public_site/blocks/custom_blocks/widgets/mapBlock.tsx